import { __awaiter } from "tslib";
import WebSocket from 'isomorphic-ws';
export function webSocketClose(ws) {
    return __awaiter(this, void 0, void 0, function* () {
        if (ws.readyState >= WebSocket.CLOSED) {
            return void 0;
        }
        let resolve;
        const promise = new Promise((_resolve, reject) => {
            resolve = _resolve;
        });
        ws.once('close', () => {
            resolve();
        });
        if (ws.readyState >= WebSocket.CLOSING) {
            return promise;
        }
        if (ws.readyState >= WebSocket.OPEN) {
            ws.close();
            return promise;
        }
        ws.once('open', () => {
            if (ws.readyState < WebSocket.CLOSING) {
                ws.close();
            }
        });
        return promise;
    });
}
